module.exports = __webpack_public_path__ + "img/eye-mask.730a67e2.svg";